import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
var GLBuffer = /*#__PURE__*/_createClass(function GLBuffer(buffer) {
  _classCallCheck(this, GLBuffer);
  this.buffer = buffer || null;
  this.updateID = -1;
  this.byteLength = -1;
  this.refCount = 0;
});
export { GLBuffer };